import { AuthState } from '@okta/okta-auth-js';

import { CompuweighMassDeletes } from '../../services/backend/CompuweighMassDeletes';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCompuweighMassDeletes: () => CompuweighMassDeletes<AuthState> = () => {
  return useBaseApiClient(CompuweighMassDeletes);
};
